<template>
    <!-- 商品调拨申请 -->
    <div>
        <content-view>
            <a-spin :spinning="spinning" tip="商品数据加载中...">
                <div class="wrap-container-in materiel-allocation-apply">
                    <a-form :form="form" layout="inline">
                        <div>
                            <a-form-item label="出库仓库">
                                <a-select :options="warehouseOptions" @change="warehouseChange" placeholder="请选择" style="width: 200px;" v-decorator="['outWarehouseId', {rules: [{required: true, message: '请输入'}]}]"></a-select>
                            </a-form-item>
                            <a-form-item label="入库仓库" v-if="dispatchType === 0">
                                <a-select placeholder="请选择" style="width: 200px;" v-decorator="['inWarehouseId', {rules: [{required: true, message: '请输入'}]}]">
                                    <template v-for="item in warehouseOptions">
                                        <a-select-option v-if="item.id !== currentWarehouse.id" :key="item.id" :value="item.value">{{item.label}}</a-select-option>
                                    </template>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div class="mt16" v-if="dispatchType === 1">
                            <a-form-item label="调拨门店">
                                <a-select placeholder="请选择" style="width: 200px;" @change="getWarehouseList" v-decorator="['dispatchShopId', {rules: [{required: true, message: '请输入'}]}]">
                                    <template v-for="item in shopOptions">
                                        <a-select-option v-if="item.id !== Number(shopId)" :key="item.id" :value="item.value">{{item.label}}</a-select-option>
                                    </template>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="入库仓库">
                                <a-select placeholder="请选择" style="width: 200px;" v-decorator="['inWarehouseId', {rules: [{required: true, message: '请输入'}]}]">
                                    <template v-for="item in inWarehouseOptions">
                                        <a-select-option v-if="item.id !== currentWarehouse.id" :key="item.id" :value="item.value">{{item.label}}</a-select-option>
                                    </template>
                                </a-select>
                            </a-form-item>
                        </div>
                        <a-divider></a-divider>
                        <div class="mb16">
                            <a-button type="primary" @click="showGoodsPicker">调拨商品选择</a-button>
                        </div>
                        <a-table
                        bordered
                        :dataSource="selectedRows"
                        :columns="columns"
                        :scroll="{y: 500}"
                        :pagination="false"
                        :rowKey="record => record.id"
                        class="wrap-table"
                        >
                            <template slot="index" slot-scope="key, row, index">
                                {{index + 1}}
                            </template>
                            <template slot="num" slot-scope="key,row">
                                <div style="width: 150px;">
                                    <a-form-item>
                                        <a-input-number @change="change($event, row)" v-model="row.num" style="width: 100%;" placeholder="请输入" />
                                        <div v-if="row.showError" class="text-fail">所填值必须为正整数</div>      
                                    </a-form-item>
                                </div>
                            </template>
                            <template slot="actions" slot-scope="key,row">
                                <a class="text-primary" @click="batchAddRemove(key)">删除</a>
                            </template>
                        </a-table>
                        <div class="mt16">
                            <a-form-item label="调拨原因">
                                <a-textarea style="resize: none; width: 600px;" placeholder="0/200" v-decorator="['reason', {rules: [{ required: true, message: '请输入调拨原因'}, { max: 200, message: '字数超出' }, {whitespace: true, message: '调拨原因不能为空字符'}]}]" />
                            </a-form-item>
                        </div>
                        <div class="mt16">
                            <a-form-item label="审批人角色">
                                <a-select :options="comfirmRoleList" @change="handleSelectChange" placeholder="请选择" style="width: 200px;" v-decorator="['approvalRoleId', {rules: [{required: true, message: '请输入'}]}]"></a-select>
                            </a-form-item>
                            <a-form-item label="审批人">
                                <a-select :options="memberList" placeholder="请选择" style="width: 200px;" v-decorator="['approvalUserId', {rules: [{required: true, message: '请输入'}]}]"></a-select>
                            </a-form-item>
                        </div>
                    </a-form>
                    <a-divider></a-divider>
                    <div class="text-center">
                        <a-button type="primary" @click="submit" :loading="submitLoading">提交调拨申请</a-button>
                    </div>
                </div>
            </a-spin>
            <goods-batch-picker ref="goodsBatchPicker" :warehouseName="currentWarehouse.warehouseName" :goodsList="allGoodsList" :selectedRowKeys="selectedRowKeys" @confirm="selectGoodsModalConfirm"></goods-batch-picker>
        </content-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import goodsBatchPicker from "@/components/modules/storage/goods-batch-picker.component";
    const columns = [
        {
            title: '序号',
            scopedSlots: {customRender: 'index'},
            width: 70
        },
        {
            title: '商品编号',
            dataIndex: 'goodsNo',
            width: 250
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification',
            width: 100
        },
        {
            title: '所在仓库库存',
            dataIndex: 'currentInventory',
            width: 100
        },
        {
            title: '可调拨数量',
            dataIndex: 'availableInventory',
            width: 100
        },
        {
            title: '调拨数量',
            dataIndex: 'num',
            scopedSlots: { customRender: 'num' },
            width: 183
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions' },
            width: 100
        }
    ];
    export default {
        name: 'materielAllocationApply',
        components: {
            goodsBatchPicker
        },
        props: {
        },
        data() {
            return {
                dispatchType: 0,
                columns,
                dataSource: [{}],
                warehouseOptions: [],
                inWarehouseOptions: [],
                shopOptions: [],
                visibleBatchAddStorage: false,
                selectedRowKeys: [],
                selectedRows: [],
                allGoodsList: [],
                memberList: [],
                comfirmRoleList: [],
                comfirmMemberList: [],
                submitLoading: false,
                currentWarehouse: {},
                spinning: false
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @change 入库数输入回调
             */
            change(val, record) {
                if (val === null || typeof val === 'undefined') {
                    return false;
                }
                const regExp = /^[1-9]{1,}\d*$/;
                if (!regExp.test(val)) {
                    record.showError = true;
                } else {
                    record.showError = false;
                }
            },
            warehouseChange() {
                this.selectedRowKeys = [];
                this.selectedRows = [];
                this.allGoodsList = [];
                this.form.resetFields('inWarehouseId');
                setTimeout(() => {
                    this.getCategoryAndGoods();
                }, 200);
            },
            /**
             * @showGoodsPicker 打开批量商品选择
             */
            showGoodsPicker() {
                this.$refs.goodsBatchPicker.visible = true;
            },
            /**
             * @selectGoodsModalConfirm 批量商品选择弹窗确定
             */
            selectGoodsModalConfirm({selectedRowKeys, selectedRows}) {
                this.selectedRows.forEach(item => {
                    item.num = undefined;
                });
                this.selectedRowKeys = selectedRowKeys;
                this.selectedRows = selectedRows;
            },
            /**
             * @getCategoryAndGoods 获取分组及分组下所有商品信息
             */
            getCategoryAndGoods() {
                if (!this.shopId) {
                    return false;
                }
                this.currentWarehouse = this.warehouseOptions.find(item => item.id === this.form.getFieldValue('outWarehouseId'));
                this.spinning = true;
                this.$api.newStorage.selfCategoryAndGoods({
                    body: {
                        shopId: this.shopId,
                        warehouseId: this.currentWarehouse.id 
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.vos.forEach($item => {
                                $item.categoryId = item.id;
                            });
                        });
                        this.allGoodsList = res;
                    }
                    this.spinning = false;
                });
            },
            /**
             * @getWarehouseList 获取门店下仓库列表
             */
            getWarehouseList(shopId) {
                if (!this.shopId || !typeof shopId === 'undefined') {
                    return false;
                }
                this.form.resetFields(['inWarehouseId']);
                this.inWarehouseOptions.length = 0;
                this.$api.newStorage.selfWarehousePage({
                    body: {
                        shopId: shopId || this.shopId,
                        pageNum: 1,
                        pageSize: 999999
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        if (typeof shopId !== 'undefined') {
                            this.inWarehouseOptions = res.data;
                        } else {
                            this.warehouseOptions = res.data;
                            if (Boolean(res.data[0])) {
                                this.form.setFieldsValue({
                                    outWarehouseId: res.data[0].id
                                });
                                this.getCategoryAndGoods();
                            }
                        }
                        
                    }
                });
            },
            /**
             * @getShopList 获取门店列表
             */
            getShopList() {
                this.$api.totalPlatform.selectList({}).then(res => {
                    res.forEach(item => {
                        item.value = item.id;
                        item.label = item.name;
                    });
                    this.shopOptions = res;
                });
            },
            /**
             * @batchAddRemove 批量增加项删除
             */
            batchAddRemove(id) {
                this.selectedRowKeys = this.selectedRowKeys.filter(item => item !== id);
                this.selectedRows = this.selectedRows.filter(item => item.id !== id);
            },
            /**
             * @comfirmRole 审核人职位
             */
            comfirmRole() {
                if(!this.shopId) {
                    return false;
                }
                this.$api.audit.sysRoleRefund({
                }).then(res => {
                    res.forEach(item => {
                        item.label = item.roleName;
                        item.value = item.id;
                    });
                    this.comfirmRoleList = res;
                });
            },
            /**
             * @comfirmMember 审核人 根据职位筛选
             */
            comfirmMember() {
                if(!this.shopId) {
                    return false;
                }
                this.$api.audit.sysUserRefund({
                    params: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    res.forEach(item => {
                        item.label = item.name;
                        item.value = item.id;
                    });
                    this.memberList = res.filter(i => i.id !== this.userInfo.id);
                });
            },
            //切换审核人职位下拉时，改变审核人下拉为当前职位下的人
            handleSelectChange(value) {
                // value.key: 职位ID，value.label: 职位name
                this.form.resetFields(['approvalUserId']);
                // this.memberList = this.comfirmMemberList.filter(item => item.roleId == value);
                this.comfirmMember();
            },
            /**
             * @submit 提交出库申请
             */
            submit() {
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    values.applyUserId = this.userInfo.id;
                    values.applyUserName = this.userInfo.name;
                    values.submitter = this.userInfo.account;
                    values.approvalRoleName = this.comfirmRoleList.find(item => item.id === values.approvalRoleId).label;
                    values.approvalUserName = this.comfirmMemberList.find(item => item.id === values.approvalUserId).label;
                    if (Boolean(values.dispatchShopId)) {
                        values.dispatchShopName = this.shopOptions.find(item => item.id === values.dispatchShopId).label;
                    }
                    let { selectedRows } = this;
                    let length = selectedRows.length;
                    if (!Boolean(length)) {
                        this.$message.error('请添加商品');
                        return false;
                    }
                    for(let i = 0;i < length; i++) {
                        const regExp = /^[1-9]{1,}\d*$/;
                        let num = selectedRows[i].num;
                        if(num !== 0 && !Boolean(num) || !regExp.test(num)) {
                            this.$message.error(`请正确填写第${i + 1}项的出库数量`);
                            return false;
                        }
                    }
                    let goodsList = selectedRows.map(item => {
                        return ({
                            id: item.id,
                            num: item.num
                        });
                    });
                    this.submitLoading = true;
                    this.$api.newStorage.selfGoodsDispatch({
                        body: {
                            ...values,
                            goodsList,
                            dispatchType: this.dispatchType,
                            shopId: this.shopId,
                        }
                    }).then(res => {
                        this.$message.success('操作成功');
                        this.selectedRowKeys = [];
                        this.selectedRows = [];
                        this.form.resetFields();
                        this.submitLoading = false;
                        setTimeout(() => {
                            this.$router.back();
                        }, 300);
                    }).catch(err => {
                        this.submitLoading = false;
                    });
                });
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.dispatchType = Number(this.$route.params.dispatchType);
            this.getShopList();
            this.comfirmRole();
            this.comfirmMember();
            this.getWarehouseList();
        },
        watch: {
            shopId() {
                this.form.resetFields(['dispatchShopId', 'outWarehouseId', 'inWarehouseId']);
                this.inWarehouseOptions.length = 0;
                this.selectedRowKeys.length = 0;
                this.selectedRows.length = 0;
                this.allGoodsList.length = 0;
                this.currentWarehouse = {};
                this.comfirmRole();
                this.comfirmMember();
                this.getWarehouseList();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.materiel-allocation-apply {
    min-height: 70vh;
    .ant-form-item-label {
        width: 100px;
        text-align: left;
    }
}
</style>
